import React from 'react'

function TestInput() {
  return (
    <div>
      <input type='text' />
    </div>
  )
}

export default TestInput
